import {
  UPDATE_REPORT,
  RESET_REPORT
} from "./actionTypes"

export const update_report = report => {
  return {
    type: UPDATE_REPORT,
    payload: report,
  }
}

export const reset_report = report => {
  return {
    type: RESET_REPORT,
  }
}
